import React from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { FiFacebook, FiTwitter, FiInstagram, FiYoutube, FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import './BiographyPage.css';

const SharadhaMuttPage = ({ onBack, onNavigate }) => {
  const navigate = (target) => {
    if (onNavigate) onNavigate(target);
    else if (onBack) onBack();
  };
  return (
    <div className="bio-page">

      {/* Navbar */}
      <nav className="bio-navbar">
        <div className="bio-navbar-logo">
          <img src="/Sndp/logo.png" alt="Pravasi SNDP Yogam Logo" />
        </div>
        <div className="bio-navbar-links">
          <div className="bio-nav-menu">
            <a href="#home" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('home'); }}>Home</a>
            <div className="bio-nav-about-wrapper">
              <span className="bio-nav-link bio-nav-dropdown">
                About <FiChevronDown size={14} />
              </span>
              <div className="bio-nav-about-dropdown">
                <button onClick={() => navigate('ourhistory')}>Our History</button>
                <button onClick={() => navigate('leadership')}>Leadership</button>
              </div>
            </div>
            <a href="#gallery" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('gallery'); }}>Gallery</a>
            <a href="#news" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('news'); }}>News &amp; Articles</a>
            <a href="#eventcalendar" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('eventcalendar'); }}>Event Calendar</a>
            <a href="#constitution" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('constitution'); }}>Constitution</a>
            <a href="#membership" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('membership'); }}>Membership</a>
            <a href="#contact" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('contact'); }}>Contact Us</a>
          </div>
          <a href="#donate" className="bio-donate-btn">Donation</a>
        </div>
      </nav>

      {/* Hero Image */}
      <div className="bio-hero-image">
        <img src="/Sndp/sivagiri-mutt-varkala-kerala-1-attr-hero.jpg" alt="Sivagiri Mutt" />
      </div>

      {/* Page Title */}
      <div className="bio-page-title">
        <h1>Sharadha Mutt</h1>
        <div className="bio-title-bar"></div>
      </div>

      {/* Main Content */}
      <div className="bio-content">

        <div className="bio-section-heading">
          <span>Sharadha Mutt</span>
        </div>
        <p className="bio-text">
          The Goddess of knowledge and wisdom, Mother Goddess Sri Sharadamba was installed at Sivagiri Saradamutt on 1st May 1912 (M. E. 1087 Medam 18). Sri Sharadamba, the supreme patron goddess of all fine arts and education, carrying a bird, a book, a pot full of nectar, and chinmudra (the symbol of salvation), in her four hands, is seated on a fullblown lotus flower. The temple is a beautiful structure, octagonal in shape, with walls pure white in colour, and windows panelled with dark blue glass. The structure is enclosed in a circular half-wall, with white sand spread on the space between the temple and the half-wall. This whole structure, with a special stage for prayers in front of it, renders a special splendour and attraction to the ambience. Devotees assemble on the stage and spend time in prayers, recitations and meditation. This is an ideal spot for marriages, first rice feeding of babies and initiation to education for children.
        </p>

      </div>

      {/* Footer */}
      <footer className="bio-footer">
        <div className="bio-footer-main">
          <div className="bio-footer-brand">
            <div className="bio-footer-logo-row">
              <img src="/Sndp/logo.png" alt="Logo" className="bio-footer-logo-img" />
              <div className="bio-footer-brand-info">
                <h3 className="bio-footer-brand-name">Pravasi SNDP Yogam, UK Bristol</h3>
                <p className="bio-footer-brand-desc">
                  We, Pravasi SNDP Yogam members, are the devotees of Sree Narayana Guru,
                  a revered saint and social reformer from Kerala, India (1854-1928).
                </p>
                <div className="bio-footer-socials">
                  <a href="#facebook" aria-label="Facebook"><FiFacebook size={20} color="#FFC501" /></a>
                  <a href="#twitter" aria-label="Twitter"><FiTwitter size={20} color="#FFC501" /></a>
                  <a href="#instagram" aria-label="Instagram"><FiInstagram size={20} color="#FFC501" /></a>
                  <a href="#youtube" aria-label="YouTube"><FiYoutube size={28} color="#FFC501" /></a>
                </div>
              </div>
            </div>
          </div>

          <div className="bio-footer-contact">
            <h4 className="bio-footer-column-title">Contact Us</h4>
            <div className="bio-footer-contact-list">
              <div className="bio-footer-contact-item">
                <FiMapPin size={20} color="#FFC501" />
                <span>Almondsbury Creative 10 Gloucester Road, Bristol</span>
              </div>
              <div className="bio-footer-contact-item">
                <FiPhone size={20} color="#FFC501" />
                <span>+91 84524145547</span>
              </div>
              <div className="bio-footer-contact-item">
                <FiMail size={20} color="#FFC501" />
                <span>sndpyogamuk@gmail.com</span>
              </div>
            </div>
          </div>

          <div className="bio-footer-links">
            <h4 className="bio-footer-column-title">Quick Links</h4>
            <ul className="bio-footer-nav">
              <li><a href="#home" onClick={onBack}>Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#history">History</a></li>
              <li><a href="#organization">Organization</a></li>
              <li><a href="#sree-narayana-guru">Sree Narayana Guru</a></li>
              <li><a href="#articles">Articles</a></li>
              <li><a href="#gallery">Gallery</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="bio-footer-newsletter">
            <h4 className="bio-footer-column-title">Newsletter</h4>
            <p className="bio-newsletter-desc">Subscribe to our Newsletter</p>
            <div className="bio-newsletter-form">
              <input type="email" placeholder="Enter your email" />
              <button type="button">Subscribe</button>
            </div>
          </div>
        </div>

        <div className="bio-footer-bottom">
          <span>© 2025 Pravasi SNDP Yogam. All rights reserved.</span>
          <div className="bio-footer-bottom-links">
            <a href="#terms">Terms of Use</a>
            <a href="#privacy">Privacy Policy</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SharadhaMuttPage;
